// extracted by mini-css-extract-plugin
export default {"hire_because":"HireBecome_hire_because__ldEVL"};